import React from 'react';
import { SchematicShell, Line } from './SchematicPrimitives';

const IN = 0.0254;
const PANEL_THICK = 0.5 * IN;
const POST_W = 1.5 * IN;
const TIER_TARGET = 6 * IN;

export function DormShoeRackSchematic({
  widthMeters: width,
  heightMeters: height,
  depthMeters: depth,
  view = 'front',
  strokeColor,
  strokeWidth,
}) {
  const isSide = view === 'left' || view === 'right';
  const w = isSide ? depth : width;
  const postInset = isSide ? POST_W : POST_W;

  const innerH = height - PANEL_THICK * 2;
  const numTiers = Math.max(2, Math.round(innerH / TIER_TARGET));
  const numShelves = numTiers - 1;
  const tierH = innerH / numTiers;

  const shelves = [];
  for (let i = 1; i <= numShelves; i++) {
    const y = height - PANEL_THICK - i * tierH;
    shelves.push(
      <Line
        key={`shelf-${i}`}
        x1={postInset}
        y1={y}
        x2={w - postInset}
        y2={y}
        strokeColor={strokeColor}
        strokeWidth={strokeWidth}
      />
    );
  }

  return (
    <SchematicShell
      width={w}
      height={height}
      strokeColor={strokeColor}
      strokeWidth={strokeWidth}
    >
      {/* Left post */}
      <Line
        x1={postInset}
        y1={PANEL_THICK}
        x2={postInset}
        y2={height - PANEL_THICK}
        strokeColor={strokeColor}
        strokeWidth={strokeWidth}
      />
      {/* Right post */}
      <Line
        x1={w - postInset}
        y1={PANEL_THICK}
        x2={w - postInset}
        y2={height - PANEL_THICK}
        strokeColor={strokeColor}
        strokeWidth={strokeWidth}
      />
      {shelves}
    </SchematicShell>
  );
}

DormShoeRackSchematic.supportsSideViews = true;
